import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { NAV } from "@/constants/testIds";

const links = [
  { to: "/about", label: "About", id: NAV.about },
  { to: "/chess-leadership", label: "Chess Leadership", id: NAV.chess },
  { to: "/news", label: "Newsroom", id: NAV.news },
  { to: "/videos", label: "Videos", id: NAV.videos },
  { to: "/companies", label: "Companies", id: NAV.companies },
  { to: "/thought-leadership", label: "Thought Leadership", id: NAV.thought },
  { to: "/speaking", label: "Speaking", id: "nav-speaking" },
  { to: "/media-kit", label: "Media Kit", id: NAV.mediaKit },
  { to: "/gallery", label: "Gallery", id: NAV.gallery },
  { to: "/contact", label: "Contact", id: NAV.contact },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => { setOpen(false); }, [loc.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-50 backdrop-blur-md transition-all ${scrolled ? "bg-[rgba(250,248,243,0.92)] border-b hairline" : "bg-[rgba(250,248,243,0.85)]"}`}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-4 lg:py-5 flex items-center justify-between">
        <Link to="/" data-testid={NAV.brand} className="flex items-center gap-3 group">
          <div className="w-8 h-8 border hairline flex items-center justify-center text-[#0a1628]">
            <span className="font-display text-xl leading-none">N</span>
          </div>
          <div className="leading-tight">
            <div className="font-display text-xl tracking-tight">Nitin Narang</div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-[#6b6b6b]">President · AICF</div>
          </div>
        </Link>

        <nav className="hidden xl:flex items-center gap-7">
          {links.map(l => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.id}
              className={({isActive}) => `text-[12px] tracking-[0.14em] uppercase font-medium link-underline ${isActive ? "text-[#b8975d]" : "text-[#2c2c2c] hover:text-[#0a1628]"}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          data-testid={NAV.mobileToggle}
          className="xl:hidden p-2 border hairline"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          <i className={`fa-solid ${open ? "fa-xmark" : "fa-bars"} text-[#0a1628]`}></i>
        </button>
      </div>

      {open && (
        <div className="xl:hidden border-t hairline bg-[#faf8f3]">
          <div className="max-w-[1400px] mx-auto px-6 py-4 flex flex-col gap-3">
            {links.map(l => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`${l.id}-mobile`}
                className={({isActive}) => `text-sm tracking-[0.14em] uppercase font-medium py-2 ${isActive ? "text-[#b8975d]" : "text-[#0a1628]"}`}
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
